import script from "./AppNotification.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppNotification.vue?vue&type=script&setup=true&lang=ts"

import "./AppNotification.vue?vue&type=style&index=0&id=328561b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-328561b8"]])

export default __exports__